(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sos-custom-gear"]) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.gearReady === 'true') return;
    const { variants, strings: t } = JSON.parse(root.querySelector('[data-gear-config]').textContent);
    const form = root.querySelector('form');
    const select = root.querySelector('[data-variant]');
    const submit = root.querySelector('[data-submit]');
    const error = root.querySelector('[data-error]');
    const files = [...root.querySelectorAll('[data-artwork]')];
    let sending = false;
    const variant = () => variants.find(v => String(v.id) === select.value);
    const showError = message => { error.textContent = message; error.hidden = !message; };
    const sync = () => {
      const v = variant();
      const jersey = !!v && (v.title === 'Jersey' || v.title === 'Jersey & Pants Combo');
      const pants = !!v && (v.title === 'Pants' || v.title === 'Jersey & Pants Combo');
      root.querySelectorAll('[data-piece]').forEach(group => {
        const enabled = group.dataset.piece === 'jersey' ? jersey : pants;
        group.hidden = !enabled;
        group.querySelectorAll('input,select,textarea').forEach(input => {
          input.disabled = !enabled;
          if (!enabled) input.setCustomValidity('');
        });
      });
      if (v) root.querySelector('[data-price]').textContent = v.money;
      submit.disabled = sending || !v || !v.available;
      showError(v && !v.available ? t.unavailable : '');
      const url = new URL(window.location.href);
      if (v) url.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', url);
    };
    const validateFile = input => {
      if (input.disabled) return true;
      const file = input.files[0];
      let message = '';
      if (!file) message = t.file_required;
      else if (!/\.(pdf|ai|svg|zip)$/i.test(file.name)) message = t.file_invalid;
      else if (!file.size) message = t.file_empty;
      else if (file.size > 10 * 1024 * 1024) message = t.file_large;
      input.setCustomValidity(message);
      input.closest('.sos-gear__upload').querySelector('[data-file-state]').textContent = message || file.name;
      return !message;
    };
    select.addEventListener('change', sync);
    files.forEach(input => input.addEventListener('change', () => { validateFile(input); showError(''); }));
    form.addEventListener('submit', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (sending) return;
      const v = variant();
      if (!v || !v.available) { showError(v ? t.unavailable : t.variant_required); return; }
      const valid = files.map(validateFile).every(Boolean);
      if (!valid || !form.reportValidity()) { form.reportValidity(); return; }
      sending = true;
      submit.disabled = true;
      submit.textContent = t.adding;
      showError('');
      form.method = 'post';
      form.enctype = 'multipart/form-data';
      HTMLFormElement.prototype.submit.call(form);
    }, true);
    window.addEventListener('pageshow', () => { sending = false; submit.textContent = t.add; sync(); });
    sync();
    root.dataset.gearReady = 'true';
  };
  const scan = scope => scope.querySelectorAll('[data-sos-custom-gear]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sos-custom-gloves"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready === 'true') return;
    const config = JSON.parse(root.querySelector('[data-config]').textContent);
    const { variants, strings: t } = config;
    if (!variants.length) return;
    const form = root.querySelector('form');
    const variantInput = root.querySelector('[data-variant]');
    const modelSelect = root.querySelector('[data-model-select]');
    const size = root.querySelector('[data-size]');
    const hand = root.querySelector('[data-hand]');
    const upload = root.querySelector('[data-artwork]');
    const error = root.querySelector('[data-error]');
    const submit = root.querySelector('[data-submit]');
    const bundleProperty = root.querySelector('[data-bundle-property]');
    let model = 'Rad';
    let submitting = false;
    const showError = (message) => { error.textContent = message; error.hidden = !message; };
    const getVariant = () => variants.find(v => v.model === model && v.size === size.value && v.hand === (model === 'Golf' ? hand.value : 'Both hands'));
    const update = () => {
      const selected = getVariant();
      variantInput.value = selected ? String(selected.id) : '';
      const priced = selected || variants.find(v => v.model === model);
      if (priced) root.querySelector('[data-price]').textContent = priced.money;
      showError(selected && !selected.available ? t.unavailable : '');
      const url = new URL(window.location.href);
      if (selected) url.searchParams.set('variant', selected.id);
      else url.searchParams.delete('variant');
      window.history.replaceState(window.history.state, '', url);
    };
    const chooseModel = (name) => {
      model = name;
      const golf = name === 'Golf';
      const cycling = name === 'Cycling';
      root.querySelectorAll('[data-template-group]').forEach(group => { group.hidden = group.dataset.templateGroup !== (cycling ? 'cycling' : 'shared'); });
      root.querySelector('[data-sample-note]').textContent = t[cycling ? 'cycling_sample_note' : 'sample_note'];
      modelSelect.value = name;
      root.querySelector('[data-badge-unit]').textContent = t[golf ? 'badge_gloves' : 'badge_pairs'];
      root.querySelector('[data-badge-detail]').textContent = t[golf ? 'badge_hand' : 'badge_design'];
      const sizes = [...new Set(variants.filter(v => v.model === name).map(v => v.size))];
      size.replaceChildren(new Option(t.choose_size, ''), ...sizes.map(value => new Option(value, value)));
      size.value = '';
      hand.value = '';
      hand.required = golf;
      hand.disabled = !golf;
      root.querySelector('[data-hand-field]').hidden = !golf;
      root.querySelector('[data-model-info]').textContent = t[name.toLowerCase() + '_info'];
      root.querySelector('[data-bundle-label]').textContent = t[golf ? 'golf_bundle' : 'pair_bundle'];
      root.querySelector('[data-bundle-note]').textContent = t[golf ? 'golf_note' : 'pair_note'];
      bundleProperty.value = t[golf ? 'bundle_golf_order' : 'bundle_pairs_order'];
      update();
    };
    const validateFile = () => {
      const file = upload.files[0];
      let message = '';
      if (!file) message = t.file_required;
      else if (!/\.(pdf|ai)$/i.test(file.name)) message = t.invalid_file;
      else if (!file.size) message = t.empty_file;
      else if (file.size > 10 * 1024 * 1024) message = t.file_too_large;
      upload.setCustomValidity(message);
      root.querySelector('[data-file-state]').textContent = message || (file ? file.name : t.upload_help);
      return !message;
    };
    const requestedId = new URL(window.location.href).searchParams.get('variant') || variantInput.value;
    const requested = variants.find(v => String(v.id) === requestedId);
    modelSelect.addEventListener('change', () => chooseModel(modelSelect.value));
    size.addEventListener('change', update);
    hand.addEventListener('change', update);
    upload.addEventListener('change', () => { validateFile(); showError(''); });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitting) return;
      const variant = getVariant();
      if (!variant || !variant.available) {
        showError(variant ? t.unavailable : t.selection_required);
        if (!size.value) size.focus();
        else if (model === 'Golf' && !hand.value) hand.focus();
        return;
      }
      if (!validateFile() || !form.reportValidity()) { form.reportValidity(); return; }
      variantInput.value = String(variant.id);
      showError('');
      submitting = true;
      submit.disabled = true;
      submit.textContent = t.adding;
      form.method = 'post';
      form.enctype = 'multipart/form-data';
      HTMLFormElement.prototype.submit.call(form);
    }, true);
    window.addEventListener('pageshow', () => {
      submitting = false;
      submit.disabled = false;
      submit.textContent = t.add_bundle;
    });
    variantInput.required = false;
    root.querySelector('[data-fallback]').hidden = true;
    root.querySelector('[data-enhanced]').hidden = false;
    size.disabled = false;
    modelSelect.disabled = false;
    bundleProperty.disabled = false;
    chooseModel(requested ? requested.model : 'Rad');
    if (requested) { size.value = requested.size; hand.value = requested.hand; update(); }
    root.dataset.ready = 'true';
  };
  const scan = (scope) => scope.querySelectorAll('[data-sos-custom-gloves]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
